import React from'react';import{isAvailable}from'@shopgate/native-modules';import PaypalButtonWeb from"./PaypalButtonWeb";import PaypalButtonApp from"./PaypalButtonApp";/**
 * Paypal
 * @param {Object} props Props
 * @returns {JSX}
 */var PaypalButton=function PaypalButton(props){if(!isAvailable()){return React.createElement(PaypalButtonWeb,props);}return React.createElement(PaypalButtonApp,props);};export default PaypalButton;